// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3jtzw","col":"styles_col__3a21i"};